import { render, staticRenderFns } from "./VScrollView.vue?vue&type=template&id=f029a842"
import script from "./VScrollView.vue?vue&type=script&lang=ts"
export * from "./VScrollView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports